import DeliveryMethodDetail from './DeliveryMethodDetail';

export default DeliveryMethodDetail;



// WEBPACK FOOTER //
// ./src/scenes/DeliveryMethods/DeliveryMethodDetail/index.ts